import script from "./InfoUsersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoUsersSection.vue?vue&type=script&setup=true&lang=js"

import "./InfoUsersSection.vue?vue&type=style&index=0&id=1c8bc479&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LEGION\\Desktop\\SONNAR\\proiBueno\\virgen\\reppsoc-ppqy9-portaltuturesweb\\reppsoc-ppqy9-portaltuturesweb\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c8bc479"]])

export default __exports__